<template>
  <div v-if="total > 0">
    <div v-for="[place, percent] of top5" :key="place.grid" class="flex items-stretch p-4 border-b border-line">
      <div class="w-8/12 flex flex-col justify-between items-stretch py-2">
        <div class="mb-1">{{place.name}}</div>
        <div class="relative h-2">
          <div class="absolute bg-line h-full" :style="{width: `${percent}%`}"></div>
        </div>
      </div>
      <div class="ml-auto leading-none self-end">
        <span class="text-5xl leading-none">{{percent}}</span>%
      </div>
    </div>
  </div>
</template>

<script>
import { reverseLookup } from '@/services/places'

export default {
  data() {
    return {
      top5: [],
      total: 0,
    }
  },
  props: {
    stats: {
      type: Object,
      required: true
    },
  },
  created() {
    this.computeTop5()
  },
  watch: {
    stats() {
      this.computeTop5()
    }
  },
  methods: {
    async computeTop5() {
      /**
       * Stats format:
       * [grid: string]: number;
       */
      const entries = Object.entries(this.stats).sort(([,a], [,b]) => b - a);
      const top5 = entries.slice(0, 5);
      const otherCount = entries.slice(5).reduce((sum, [,v]) => sum + v, 0);
      const total = top5.reduce((sum, [,v]) => sum + v, 0) + otherCount;
      this.total = total;

      const top5Names = Promise.all(
        top5.map(async ([grid, count]) => {
          const place = await reverseLookup(grid);
          const percent = Math.round(100 * count / total);
          return [place, percent];
        })
      );

      this.top5 = await top5Names;

      if(otherCount > 0) {
        const otherPercent = Math.round(100 * otherCount / total);
        this.top5.push([{name: 'Altre località'}, otherPercent]);
      }
    }
  }

}
</script>

<style>

</style>